<template>
    <v-container class="py-16" id="quality">
        <v-row justify="center" class="pt-6">
            <v-col
                cols="8"
                md="6"
                class="d-flex justify-center"
            >
                <v-img
                    src="@/assets/quality_fundamentals.png"
                    max-width="450"
                    alt="Prospiras core values that pertain to our commitment to quality"
                ></v-img>
            </v-col>

            <v-col
                cols="8"
                md="6"
                class="d-flex flex-column justify-center align-center"
            >
                <v-card flat>
                    <v-card-title class="text-h4 orange--text text--darken-4 justify-center font-weight-medium nowrap">
                        Quality Mission Statement
                    </v-card-title>

                    <v-card-subtitle
                        class="grey--text text--darken-4 text-body-1 font-italic font-weight-medium text-center pt-3"
                    >
                        “Serving Society with Superior Quality”
                    </v-card-subtitle>

                    <v-card-text class="text-center pt-3 grey--text text--darken-4">
                        <p class="text-body-1">
                            We aspire to offer the best for our customers and to society, 
                            not only in terms of our products, services and technology, 
                            but in all of our corporate activities. Our commitment to quality
                            stems not from want of profit, but from a passion for improving the 
                            safety and lives of people everywhere. Through our mission, we can 
                            strive to be a company trusted by the world - a company in which 
                            all of us can take great pride.
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'QualityPolicy'
}
</script>

<style scoped>
    .nowrap {
        white-space: nowrap;
    }

    .title {
        border-radius: 100%;
        border: 3px solid #00B1C3;
        height: 150px;
        width: 150px;
    }
</style>